import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { products } from "../data/products";
import { ProductCard } from "./ProductCard";
import { Reveal } from "./Reveal";

const featured = [products[0], products[4], products[6]];

export const FeaturedPieces = () => (
  <section className="py-28 md:py-36" data-testid="featured-section">
    <div className="mx-auto max-w-7xl px-6 md:px-10">
      <div className="mb-16 flex flex-wrap items-end justify-between gap-6">
        <Reveal>
          <p className="mb-4 text-xs uppercase tracking-[0.35em] text-golddark">Selected pieces</p>
          <h2 className="font-serif text-4xl leading-tight tracking-tight text-ink md:text-5xl">
            Worn close, <em className="italic text-golddark">kept forever</em>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <Link
            to="/catalogue"
            data-testid="featured-view-all-link"
            className="gold-underline flex items-center gap-2 pb-1 text-xs uppercase tracking-[0.25em] text-ink"
          >
            View the catalogue <ArrowRight size={14} strokeWidth={1.5} />
          </Link>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 gap-x-6 gap-y-14 md:grid-cols-3">
        {featured.map((p, i) => (
          <div key={p.handle} className={i === 1 ? "md:translate-y-14" : ""}>
            <ProductCard product={p} index={i} />
          </div>
        ))}
      </div>
    </div>
  </section>
);
